import { useRef } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const api = useRef({
    cancel: translate({ id: 'setup.driverActivity.dynamicLoadsCf.copyModal.button.cancel' }),
    copy: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.button.copy',
    }),

    modalTitle: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.modalCopyReasonsTitle',
    }),
    modalSubTitle: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.modalCopyReasonsSubtitle',
    }),

    territoryDropdownTitle: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.territoriesTitle',
    }),

    success: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.success.messageDescription',
    }),
    error: translate({
      id: 'setup.driverActivity.dynamicLoadsCf.copyModal.failure.messageDescription',
    }),
    warningCard: {
      title: translate({ id: 'setup.driverActivity.dynamicLoadsCf.copyModal.warningCard.title' }),
      description: translate({
        id: 'setup.driverActivity.dynamicLoadsCf.copyModal.warningCard.description',
      }),
    },
  })

  return api.current
}
